export const PrescriptionCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',
  minWidth: 'G3',

  HeaderRow: {
    flow: 'x',
    align: 'center flex-start',
    justifyContent: 'space-between',
    MedicationName: {
      text: (el, s) => s.drugName || '',
      fontSize: 'A',
      fontWeight: '700',
      color: 'inkText'
    },
    StatusBadge: {
      tag: 'span',
      text: (el, s) => s.status || '',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => {
        const st = s.status
        if (st === 'Active') return 'green.15'
        if (st === 'Expired') return 'red.15'
        if (st === 'RefillDue') return 'amber.15'
        return 'inkSurface'
      },
      color: (el, s) => {
        const st = s.status
        if (st === 'Active') return 'green'
        if (st === 'Expired') return 'red'
        if (st === 'RefillDue') return 'amber'
        return 'inkMuted'
      }
    }
  },

  DosageForm: {
    text: (el, s) => [s.dosage, s.form].filter(Boolean).join(' - '),
    fontSize: 'Z',
    color: 'inkText'
  },
  Frequency: {
    text: (el, s) => (s.frequency ? `Frequency: ${s.frequency}` : ''),
    fontSize: 'Z',
    color: 'inkMuted'
  },

  Indication: {
    if: (el, s) => !!s.indication,
    text: (el, s) => `Indication: ${s.indication}`,
    fontSize: 'Z',
    color: 'inkMuted',
    fontStyle: 'italic'
  },
  DetailsRow: {
    flow: 'x',
    gap: 'A',
    flexWrap: 'wrap',
    Duration: {
      flow: 'y',
      gap: 'X',
      Label: {
        text: (el, s) => 'Duration',
        fontSize: 'Y',
        color: 'inkMuted'
      },
      Value: {
        text: (el, s) => s.duration || '',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkText'
      }
    },
    Refills: {
      flow: 'y',
      gap: 'X',
      Label: {
        text: '{{ refills | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted'
      },
      Value: {
        text: (el, s) =>
          s.refillsRemaining != null ? String(s.refillsRemaining) : '',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkText'
      }
    }
  },

  Divider: { height: '1px', background: 'inkBorder' },

  PatientName: {
    text: (el, s) => (s.patientName ? `Patient: ${s.patientName}` : ''),
    fontSize: 'Y',
    color: 'inkMuted'
  },
  Prescriber: {
    text: (el, s) => (s.prescribedBy ? `Prescriber: ${s.prescribedBy}` : ''),
    fontSize: 'Y',
    color: 'inkMuted'
  },
  DateWritten: {
    text: (el, s) => (s.prescribedDate ? `Written: ${s.prescribedDate}` : ''),
    fontSize: 'Y',
    color: 'inkMuted'
  },
  PharmacyName: {
    text: (el, s) => (s.pharmacy ? `Pharmacy: ${s.pharmacy}` : ''),
    fontSize: 'Y',
    color: 'inkMuted'
  }
}
